import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { AbstractComponent } from "./abstract/abstract.component";
import { AuthService } from "../service/auth.service";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { HeaderComponent } from "./incs/header.component";
import { FormsModule } from "@angular/forms";

@Component({
    selector: "kilowant-login-setup",
    templateUrl: "../../html/main-login-setup.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, FormsModule]
})
export class LoginSetupComponent extends AbstractComponent {
    showError: boolean = false;
    error: string = "";
    showForm: boolean = false;
    changePasswordMode: boolean = false;
    showSendActivation: boolean = false;
    login: string = "";
    operationCompleted: boolean = false;
    password: string = "";
    password2: string = "";
    data: string = "";
    passwordType: string = "password";
    passwordType2: string = "password";    

    constructor(
        router: Router,
        route: ActivatedRoute,
        private authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        dialog: MatDialog) {
        super(router, route, dialog, analyticsService, generalService);
    }

    ngOnDestroy() {
    }

    ngOnInit(): void {
        if (this.authService.isLoggedIn()) {
            this.router.navigate(["/user/home"], { queryParams: { redirect: this.router.url } });
        }
        this.route.queryParams.forEach((params: Params) => {
            let data: string = params["data"];
            if (data == null || data == "") {
                this.goto("/");
            } else {
                this.generalService.loginActivateCheck(data).subscribe(
                    {
                        next: (res: any) => {
                            if (res.key) {
                                this.data = data;
                                this.showForm = true;
                                this.changePasswordMode = true;
                                this.login = res.value;
                                this.refreshView();
                            } else {
                                this.goto("/");
                            }
                        },
                        error: (err: any) => {
                            this.goto("/");
                        }
                    }
                );
            }
        });
    }

    showPassword(num: number) {
        if (num == 1) {
            if (this.passwordType === "password") {
                this.passwordType = "text";
            } else {
                this.passwordType = "password";
            }
        } else {
            if (this.passwordType2 === "password") {
                this.passwordType2 = "text";
            } else {
                this.passwordType2 = "password";
            }
        }
    }

    sendForm(): void {
        this.clearErrors();
        if (this.password == null || this.password.length == 0 || this.password2 == null || this.password2.length == 0) {
            this.setErrorText("Please enter the data requested above in order to register.");
            return;
        }
        if (this.password.length < 8) {
            this.setErrorText("Password shall be at least 8 characters long.");
            return;
        }
        if (this.password != this.password2) {
            this.setErrorText("Passwords do not match.");
            return;
        }

        this.generalService.loginActivateProceed(this.data, this.password).subscribe(
            {
                next: (res: any) => {
                    this.operationCompleted = true;
                    this.cdr.markForCheck();
                },
                error: (err: any) => {
                    if (err.status == 400) {
                        this.setErrorText(err.error);
                    }
                }
            }
        );
    }

    resetError(): void {
        this.showError = false;
    }
}
